import { render } from "./AppInlineMenu.vue?vue&type=template&id=60083028"
import script from "./AppInlineMenu.vue?vue&type=script&lang=js"
export * from "./AppInlineMenu.vue?vue&type=script&lang=js"

import "./AppInlineMenu.vue?vue&type=style&index=0&id=60083028&lang=css"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__